import { components } from 'cng-web-lib';
import React from 'react';
import SCOInvMgmtApiUrls from 'src/apiUrls/SCOInvMgmtApiUrls';
import pathMap from 'src/paths/PathMap_SCO_InvMgmt';
import FormProperties from './Supplier_FormProperties';
import SupplierTranslationText from './SupplierTranslationText'

const { form: { CngAddForm } } = components

function CreatePage({ history, showNotification }) {
    const translatedTextObject = SupplierTranslationText()

    return (

        <CngAddForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            shouldDisableEnterToSubmit
            showNotification={showNotification}
            history={history}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    showNotification={showNotification}
                />
            }
            buttonText={translatedTextObject.create}
            formikProps={FormProperties.formikProps}
            create={{
                url: SCOInvMgmtApiUrls.CREATE_SUPPLIER,
                successRedirect: pathMap.SCO_INV_SUPPLIER_LIST
            }}
        />
    )

}

export default CreatePage
